// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__14pz_","header":"MergedInvoice_header__1ZVYl"};